/**
 * @module fetchers/text
 */

/**
 * @typedef {Node} Target
 * @typedef {module:fetchers/fetch~Context} Context
 * @typedef {module:fetchers/fetch~Fetched} Fetched
 * @typedef {Fetched|{fetched:String}} Text
 */
import object from '../utils/object.js'
import fetch from './fetch.js'

/**
 * Fetches a request as text
 * @param {Context} context
 * @returns {Promise<Text>}
 */
export default async (
  context
) => {
  const result = await fetch(context)
  const { response } = result

  return object(result, {
    fetched: await response.clone().text()
  })
}
